import React, { useState, useEffect, useRef } from 'react';
import { Popover, Space, DatePicker, ConfigProvider, Select } from 'antd';
import moment, { Moment } from 'moment';
import { Row, Col, Button, Radio } from 'antd';
import { RightOutlined, LeftOutlined, FileExcelOutlined, PlusOutlined } from '@ant-design/icons';
import './index.scss';
import { isMobile } from 'react-device-detect';
import 'moment/locale/ko';
import classNames from 'classnames';
import { CalendarOutlined } from '@ant-design/icons';
import locale from "antd/lib/locale/ko_KR";
import { usePopupManager } from 'react-popup-manager';
import { StandbyScheduleEditModal } from 'components/molecules';

moment.locale('ko');

const HOUR_HEIGHT = 60;
const SLOT_HEIGHT = HOUR_HEIGHT / 2
const cx = classNames.bind('./index.scss');

export interface HeaderProps {
  currentMonth: Moment;
  display: string;
  prevMonth: () => void;
  nextMonth: () => void; 
  onSetSearchDate: (date: any) => void;
  status?: string;
  onChangeStatus?: (status: any) => void;
  subStatus?: string;
  onChangeSubStatus?: (status: any) => void;  
}

const RenderHeader = ({ 
  currentMonth, 
  display, 
  prevMonth, 
  nextMonth, 
  onSetSearchDate, 
  status, 
  onChangeStatus,
  subStatus,
  onChangeSubStatus
}:HeaderProps) => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const handleDateChange = (date: moment.Moment | null) => {
    if (date) {
      onSetSearchDate(moment(date).format('YYYY-MM-DD'));
      // 여기에 선택한 날짜에 맞는 스케줄 목록을 다시 불러오는(API 호출 등) 로직을 추가하세요.
    }
  };

  const openDatePicker = () => {
    setIsPickerOpen(true);
  }


  return (
    <div 
      style={{
        backgroundColor:'#FFF',
        WebkitUserSelect: 'none',  /* 사파리(iOS/macOS) 지원 */
        MozUserSelect: 'none',     /* 파이어폭스 지원 */
        userSelect: 'none',        /* 크롬, 오페라, 에지 등 표준 브라우저 지원 */         
      }}
    >
      <div className="header row">
          <div className="col col-end">
            <LeftOutlined onClick={prevMonth} />  
          </div>  
          <div style={{display: 'flex', alignItems: 'center'}}>
            <Space 
              onClick={openDatePicker} 
              style={{ 
                cursor: 'pointer', 
                fontSize: '18px', 
                fontWeight: 'bold',
                userSelect: 'none',
                padding: '4px 8px',
                borderRadius: '4px',
                transition: 'background 0.2s'
              }}
              // 마우스 오버 시 가벼운 피드백 효과
              className="hover-bg-effect"
              onMouseEnter={(e) => (e.currentTarget.style.background = '#f5f5f5')}
              onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
            >
                <span className="text">
                    {moment(currentMonth).format('YYYY년 M월')}
                </span>
                <CalendarOutlined style={{ color: '#1677ff', fontSize: '16px' }} />
            </Space> 
            <ConfigProvider locale={locale}>
              <DatePicker
                picker="date"
                value={currentMonth}
                onChange={handleDateChange}
                
                // ⭐️ 핵심: open 속성에 리액트 상태 바인딩
                open={isPickerOpen}
                
                // 사용자가 달력 바깥 영역을 클릭해 창이 닫힐 때 상태 동기화
                onOpenChange={(open) => setIsPickerOpen(open)}
                
                // 투명하게 처리하여 텍스트 위치 근처에 팝업이 이쁘게 뜨도록 공간만 유지
                style={{ 
                  visibility: 'hidden', 
                  width: 0, 
                  padding: 0, 
                  border: 'none',
                  position: 'absolute'
                }}
              />  
            </ConfigProvider>                   
          </div>
          <div className="col col-end">
            <RightOutlined onClick={nextMonth}/>   
          </div>
          {isMobile && (
            <div style={{display:'flex'}}>
              <Radio.Group
                options={[{label: '전체', value:'all'}, {label: '확정', value:'confirm'}, {label: '논의중', value:'consult'}]}
                value={status}
                optionType="button"
                buttonStyle="solid"
                size='small'
                onChange={(e)=>onChangeStatus&&onChangeStatus(e)}
              />
              {status == 'consult' && (
                <Select value={subStatus} onSelect={onChangeSubStatus} size="small" style={{width:'70px'}}>
                  <Select.Option key={'all'} value={'all'}>전체</Select.Option>
                  <Select.Option key={'link'} value={'link'}>연결</Select.Option>
                  <Select.Option key={'nolink'} value={'nolink'}>미연결</Select.Option>
                  <Select.Option key={'standby'} value={'standby'}>대기</Select.Option>
                </Select>
              )}
            </div>
          )}          
      </div>
    </div>
  );
};


const RenderDays = () => {
  const days:any[] = [];
  const date = ['일', '월', '화', '수', '목', '금', '토'];

  for (let i = 0; i < 7; i++) {
      days.push(
          <Col className="dayscell" key={i}>
              {date[i]}
          </Col>,
      );
  }

  return <Row className="daysrow">{days}</Row>;
};

const RenderWeek = (schedules: ScheduleListDto[], currentMonth: Moment, onGoday: (date:any)=>void) => {

  return (
    <div style={{ display: 'flex', width: '100%', background: '#fff'}}>
      <div style={{ flex: '0 0 60px'}} >
      </div> 
      <div style={{display: 'flex', flex:1}}>
        {schedules.map((item)=> {
          return (
            <div onClick={()=>onGoday?onGoday(item.date):null} key={item.date} className="weekcell" style={{cursor:'pointer'}}>
              {moment(item.date).format('D (dd)')}
            </div>
          )
        })}
      </div>      
    </div>
  )  
}

export interface CellProps {
  currentMonth: Moment;
  schedules: ScheduleListDto[];
  type: string;
  onClickItem: (item: DailyScheduleDto)  => void;
  makePopupContent: (item: DailyScheduleDto)  => void; 
  onGoDay?: (date: any) => void;
  onOpenStandbyPopup?: (date: any, startTime: any, endTime: any) => void;
}
const RenderCells = ({ currentMonth, schedules, type, onClickItem, makePopupContent, onGoDay, onOpenStandbyPopup}:CellProps) => {
  const monthStart = moment(currentMonth).startOf('month');
  const monthEnd = moment(monthStart).endOf('month');
  const startDate = moment(monthStart).startOf('week');
  const endDate = moment(monthEnd).endOf('week');

  const rows:any[] = [];
  let days:any[] = [];
  let day = startDate;
  let formattedDate = '';


  while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
          formattedDate = moment(day).format('D');
          const formattedDay = moment(day).format('YYYY-MM-DD');
          const idx = Number(formattedDate)-1;
          if (!!schedules && schedules.length > idx  && monthStart <= day && monthEnd >= day) {
            days.push(
              <Col 
                className={'cellLayout'} 
                key={formattedDate} 
                onClick={(e)=>{
                  if (onOpenStandbyPopup) onOpenStandbyPopup(`${formattedDay}`, '09:00', '10:00');
                }}
              >
                <span onClick={()=>onGoDay?onGoDay(`${formattedDay}`):null} style={{cursor:'pointer'}}>{formattedDate}</span>
                <ul>      
                  {schedules[idx].schedules?.map((item) => {
                  return (
                    <li key={item.id} className='schedule' >
                      <Popover 
                        placement="rightTop" 
                        content={makePopupContent(item)}
                      >
                        <a onClick={(e)=> {
                            if (!isMobile){
                              onClickItem(item); 
                            }
                            e.stopPropagation();
                          }}
                        >
                          {(type==='op')?(
                            <>
                              <span className={'lecture_status_type_' + item.lecture_status_type}>●</span> <span>{item.lecture_status_type === '2' && item.project_type==='b2b' && (item.lecture_place_type)} {item.start_time} {item.operator} {item.lecture_status_type !== '2' && item.project_type==='b2b' && (item.lecture_place_type)} {item.project_type==='b2b'&&('['+item.company_name+'] ')} {item.project_title}</span>
                            </>
                          ):(
                            <>
                              <span className={'lecture_status_type_' + item.lecture_status_type}>●</span> <span className={'lecture_place_type_' + item.lecture_place_type}>
                                {(item.lecture_status_type == '4' || item.lecture_status_type == '0') ? (
                                  <span>{item.lecture_status_type == '4'?'논의중':'대기'}_{item.start_time}~{item.end_time}_{item.lecturer_name}_{item.company_name}_{item.lecture_subject}_{item.time_count}H_{item.pm}</span>
                                ):(
                                  <span>{item.start_time}~{item.end_time} {item.lecturer_name} {isMobile ? item.lecture_subject:item.project_title}</span>
                                )}
                              </span>
                            </>
                          )}
                          
                        </a>
                      </Popover>
                    </li>                   
                  )    
                  })}                  
                </ul>
              </Col>
            );
          } else {
            days.push(
              <Col className={'cellLayout'} key={formattedDate}>
                <span onClick={()=>onGoDay?onGoDay(`${formattedDay}`):null} style={{cursor:'pointer'}}>{formattedDate}</span>
              </Col>
            );
          }

          day = moment(day).add(1, 'day');
      }
      rows.push(
          <Row className={'rowLayout my-calender'} key={day.format('YYYYMMDD')} wrap={false} >
              {days}
          </Row>,
      );
      days = [];
  }
  return <div className="cellbody">{rows}</div>;
};

const getLayoutedEvents = (list: DailyScheduleDto[]) => {
  if (list.length === 0) return [];

  // 1. 시작 시간이 빠른 순서대로 정렬 (시작 시간이 같으면 종료 시간이 늦은 순)
  const sorted = [...list].sort((a, b) => {
    const aStart = moment(a.start_time, 'HH:mm').minutes() + moment(a.start_time, 'HH:mm').hours() * 60;
    const bStart = moment(b.start_time, 'HH:mm').minutes() + moment(b.start_time, 'HH:mm').hours() * 60;
    return aStart - bStart;
  });

  // 2. 서로 겹치는(서로 간섭이 있는) 일정을 그룹별로 묶기
  const groups: DailyScheduleDto[][] = [];
  let currentGroup: DailyScheduleDto[] = [];
  let groupMaxEnd = moment('00:00', 'HH:mm');

  sorted.forEach((event) => {
    const eventStart = moment(event.start_time, 'HH:mm');
    const eventEnd = event.start_time != event.end_time ? moment(event.end_time, 'HH:mm') : moment(event.end_time, 'HH:mm').add(30, 'minute');

    // 현재 그룹이 비어있거나, 새로운 일정의 시작 시간이 현재 그룹의 '가장 늦은 종료 시간'보다 크거나 같다면 완전히 새로운 그룹 생성
    if (currentGroup.length === 0 || eventStart.isSameOrAfter(groupMaxEnd)) {
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }
      currentGroup = [event];
      groupMaxEnd = eventEnd;
    } else {
      // 시간대가 겹친다면 기존 그룹에 편입
      currentGroup.push(event);
      if (eventEnd.isAfter(groupMaxEnd)) {
        groupMaxEnd = eventEnd;
      }
    }
  });
  if (currentGroup.length > 0) {
    groups.push(currentGroup);
  }

  // 3. 각 그룹 내부에서만 열(Column)을 나누고 가로 폭 계산하기
  groups.forEach((group) => {
    const columns: DailyScheduleDto[][] = [];

    group.forEach((event) => {
      const eventStart = moment(event.start_time, 'HH:mm');
      let placed = false;

      // 해당 그룹 내부의 열들을 돌며 빈 자리가 있는지 확인
      for (let i = 0; i < columns.length; i++) {
        const lastEventEnd = columns[i][columns[i].length - 1].start_time != columns[i][columns[i].length - 1].end_time ? moment(columns[i][columns[i].length - 1].end_time, 'HH:mm') : moment(columns[i][columns[i].length - 1].end_time, 'HH:mm').add(30, 'minute');
        if (eventStart.isSameOrAfter(lastEventEnd)) {
          columns[i].push(event);
          event.colIndex = i;
          placed = true;
          break;
        }
      }

      // 들어갈 열이 없다면 새로운 열 생성
      if (!placed) {
        columns.push([event]);
        event.colIndex = columns.length - 1;
      }
    });

    // ⭐️ 중요: 전체 이벤트 개수가 아니라, '이 그룹 내에서 생성된 최대 열 개수'만 각 일정에 주입
    group.forEach((event) => {
      event.totalCols = columns.length;
    });
  });

  return sorted;
};

// 슬롯(index) 값을 시간 문자열로 바꾸는 헬퍼 함수
const convertSlotToTime = (slot: number) => {
  const hours = Math.floor(slot / 2);
  const minutes = (slot % 2) * 30;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

const RenderDisplayDay = ({ schedules, onClickItem, makePopupContent, onOpenStandbyPopup}:CellProps) => {
  const dragStartSlot = useRef<number | null>(null);
  const [dragCurrentSlot, setDragCurrentSlot] = useState<number | null>(null);
  const timelineRef = useRef<HTMLDivElement>(null);
  const touchTimer = useRef<NodeJS.Timeout | null>(null);
  const longPressed = useRef<boolean>(false); // 꾹 누르기 성공 여부 체크
  const [isDragging, setIsDragging] = useState(false)
  const isProcessing = useRef<boolean>(false);
  const isProcessingTimer = useRef<NodeJS.Timeout | null>(null); 

  // ⭐️ 공통 슬롯 계산 함수 (마우스 및 터치 좌표 처리)
  const getSlotFromClientY = (clientY: number) => {
    if (!timelineRef.current) return 0;
    const rect = timelineRef.current.getBoundingClientRect();
    const relativeY = clientY - rect.top;
    const slot = Math.floor(relativeY / SLOT_HEIGHT);
    return Math.max(0, Math.min(47, slot));

  };

  // --- 📱 터치 및 마우스 롱프레스 시작 제어 ---
  const handleStart = (clientY: number, e: any, isTouch: boolean) => {
    if (e.target.closest('.event-card-item')) return;

    e.preventDefault(); 
    
    if (isTouch) {
      if (isProcessingTimer.current) {
        clearTimeout(isProcessingTimer.current);    
        isProcessingTimer.current = null;
      } 
      isProcessing.current = true;
      isProcessingTimer.current = setTimeout(() => {
        isProcessing.current = false;
      }, 500);
    }

    if (touchTimer.current) {
      clearTimeout(touchTimer.current);    
      touchTimer.current = null;
    } 

    longPressed.current = !isTouch; // PC 마우스는 즉시 작동, 모바일 터치는 false 초기화

    const triggerAction = () => {
      const slot = getSlotFromClientY(clientY);
      dragStartSlot.current = slot;
      setDragCurrentSlot(slot);
      setIsDragging(true);

      touchTimer.current = null;

      if (isMobile) {
        const cardBody = e.target.closest('.ant-card-body') as HTMLElement;
        if (cardBody) cardBody.style.overflowY = 'hidden';
        document.body.style.overflow = 'hidden';
      }
    };

    if (isTouch) {
      touchTimer.current = setTimeout(() => {
        longPressed.current = true;
        triggerAction();
      }, 500); // 0.5초 꾹 누르기
    } else {
      triggerAction();
    }
  };  

  const handleMove = (clientY: number, e: any) => {
    if (!longPressed.current) {
      if (touchTimer.current) clearTimeout(touchTimer.current);
      touchTimer.current = null;
      return;
    }

    if (!isDragging) return;

    if (e.cancelable) {
      e.preventDefault();
    } 
    const slot = getSlotFromClientY(clientY);
    setDragCurrentSlot(slot);
  };  

  const handleEnd = (e: any, isTouch: boolean) => {
    if (longPressed.current) {
      if (e.cancelable) {
        e.preventDefault(); // 새로고침 발동 원천 차단
      }
    }

    if (touchTimer.current) {
      clearTimeout(touchTimer.current);
      touchTimer.current = null;
    }

    if (isMobile) {
      document.body.style.overflow = 'unset';
      document.querySelectorAll('.ant-card-body').forEach(el => (el as HTMLElement).style.overflowY = 'auto');
    }

    if (!isDragging || !longPressed.current || dragStartSlot.current === null || dragCurrentSlot === null) {
      setIsDragging(false);
      longPressed.current = false;
      return;
    }

    const startSlot = Math.min(dragStartSlot.current, dragCurrentSlot);
    const endSlot = Math.max(dragStartSlot.current, dragCurrentSlot) + 1;

    const startTimeStr = convertSlotToTime(startSlot);
    const endTimeStr = convertSlotToTime(endSlot);

    setIsDragging(false);
    dragStartSlot.current = null;
    longPressed.current = false;

    onOpenStandbyPopup?.(schedules[0].date, startTimeStr, endTimeStr)
  };  

  // 드래그 레이어 스타일 계산
  const getDragBoxStyle = (isDragging: boolean) => {
    if (!isDragging || dragStartSlot.current === null || dragCurrentSlot === null) return { display: 'none' };

    const start = Math.min(dragStartSlot.current, dragCurrentSlot);
    const end = Math.max(dragStartSlot.current, dragCurrentSlot) + 1;


    return {
      position: 'absolute' as const,
      top: `${start * SLOT_HEIGHT}px`,
      height: `${(end - start) * SLOT_HEIGHT}px`,
      left: 0,
      width: `100%`,
      background: 'rgba(22, 119, 255, 0.2)',
      border: '1px dashed #1677ff',
      pointerEvents: 'none' as const,
      zIndex: 5,
    };
  };  

  useEffect(() => {
    const boardEl = timelineRef.current;
    if (!boardEl) return;

    const handleNativeTouchMove = (e: TouchEvent) => {
      if (touchTimer.current) {
        clearTimeout(touchTimer.current);
        touchTimer.current = null;
      }

      if (longPressed.current) {
       if (e.cancelable) {
          e.preventDefault(); // 새로고침 발동 원천 차단
        }

        const touch = e.touches[0];
        // 기존 handleMove 로직을 네이티브 이벤트 안으로 가져옴
        const slot = getSlotFromClientY(touch.clientY);
        setDragCurrentSlot(slot);
      }
    };

    // 💡 { passive: false } 를 주어야만 e.preventDefault()가 브라우저에 의해 무시되지 않습니다.
    boardEl.addEventListener('touchmove', handleNativeTouchMove, { passive: false });

    return () => {
      boardEl.removeEventListener('touchmove', handleNativeTouchMove);
    };
  }, [isDragging]); // 주석: isDragging 상태 변화에 맞춰 바인딩 유지

  const layoutedEvents = (!schedules || schedules.length == 0) ? [] : getLayoutedEvents(schedules[0].schedules);

  return (
  <div>
    <div 
      style={{ 
        display: 'flex', 
        width: '100%', 
        background: '#fff', 
        border: '1px solid #f0f0f0', 
        borderRadius: '8px', 
        overflow: 'hidden',
        WebkitUserSelect: 'none',  /* 사파리(iOS/macOS) 지원 */
        MozUserSelect: 'none',     /* 파이어폭스 지원 */
        userSelect: 'none',        /* 크롬, 오페라, 에지 등 표준 브라우저 지원 */  
        contain: 'size layout style', 
        height:`${24 * HOUR_HEIGHT}px` 
      }}
    >      
      {/* 1. 왼쪽 영역: 시간 레이블 (고정 폭) */}
      <div style={{ flex: '0 0 60px', background: '#fafafa', borderRight: '1px solid #f0f0f0', position: 'relative', height: `${HOUR_HEIGHT * 24}px` }}>
        {Array.from({ length: 24 }).map((_, hour) => (
          <div
            key={hour}
            style={{
              position: 'absolute',
              top: `${hour * HOUR_HEIGHT - 6}px`, // 글자 중심선을 눈금선과 맞추기 위해 약간 올림
              width: '100%',
              textAlign: 'center',
              fontSize: '11px',
              color: '#8c8c8c',
            }}
          >
            {String(hour).padStart(2, '0')}:00
          </div>
        ))}
      </div> 
      {/* 2. 오른쪽 영역: 실제 스케줄 타임라인 (유연한 폭) */}
      <div 
        ref={timelineRef}
        onMouseDown={(e) => !isProcessing.current && handleStart(e.clientY, e, false)}
        onMouseMove={(e) => !isProcessing.current && handleMove(e.clientY, e)}   
        onMouseUp={(e) => !isProcessing.current && handleEnd(e, false)}
        onTouchStart={(e) => handleStart(e.touches[0].clientY, e, true)}
        //onTouchMove={(e) => handleMove(e.touches[0].clientY, e)}
        onTouchEnd={(e)=>handleEnd(e, true)}         
        /* PC 환경 */
        style={{ flex: 1, position: 'relative', height: `${HOUR_HEIGHT * 24}px`, touchAction: isDragging ? 'none' : 'pan-y', cursor: 'cell'}}
      >
        {/* 가로 가이드 배경선 그리기 */}
        {Array.from({ length: 24 }).map((_, hour) => (
          <div
            key={hour}
            style={{
              position: 'absolute',
              top: `${hour * HOUR_HEIGHT}px`,
              width: '100%',
              height: `${HOUR_HEIGHT}px`,
              borderBottom: '1px solid #f0f0f0',
              boxSizing: 'border-box',
              pointerEvents: 'none' // 배경선이 스케줄 클릭을 방해하지 않도록 설정
            }}
          />
        ))}

        {/* 실시간 드래그 박스 */}
        <div style={getDragBoxStyle(isDragging)} />

        {/* 계산된 스케줄 항목들을 절대 좌표로 배치 */}
        {layoutedEvents.map((event) => {
          const startMoment = moment(event.start_time, 'HH:mm');
          const endMoment = event.start_time != event.end_time ? moment(event.end_time, 'HH:mm'): moment(event.end_time, 'HH:mm').add(30, 'minute');
          
          // Y축 위치 및 높이 산출 (분 단위 연산)
          const top = startMoment.hours() * 60 + startMoment.minutes();
          const height = endMoment.diff(startMoment, 'minutes');

          // X축 너비 및 시작점 산출 (%)
          const width = 100 / ((event as any).totalCols || 1);
          const left = ((event as any).colIndex || 0) * width;

          return (
            <Popover 
              key={event.id}
              placement="rightTop" 
              className="event-card-item"               
              content={makePopupContent(event)}
            >
              <div
                onClick={()=> !isMobile && onClickItem(event)}
                key={event.id}
                style={{
                  position: 'absolute',
                  top: `${top}px`,
                  height: `${height}px`,
                  left: `${left}%`,
                  width: `${width}%`,
                  padding: '2px 4px 2px 2px', // 일정 카드 간 약간의 틈 생성
                  boxSizing: 'border-box',
                }}
              >
                {/* 스케줄 카드 내부 디자인 */}
                <div
                  className={cx(`schedule_event event_status_type_${event.lecture_status_type}`)}
                >
                  <span className={'lecture_place_type_' + event.lecture_place_type}>
                    {(event.lecture_status_type == '4' || event.lecture_status_type == '0') ? (
                      <span>{event.lecture_status_type == '4'?'논의중':'대기'}_{event.start_time}~{event.end_time}_{event.lecturer_name}_{event.company_name}_{event.lecture_subject}_{event.time_count}H_{event.pm}</span>
                    ):(
                      <span>{event.lecturer_name} {isMobile ? event.lecture_subject:event.project_title} {event.start_time}~{event.end_time}</span>
                    )}                    
                  </span>
                </div>
              </div>
            </Popover>            
            
          );
        })}        
      </div>      
    </div>
  </div>
  )
};

const RenderDisplayWeek = ({ currentMonth, schedules, onClickItem, makePopupContent, onOpenStandbyPopup}:CellProps) => {
  const [isDragging, setIsDragging] = useState(false)
  const dragStartSlot = useRef<number | null>(null);
  const dragStartDayIdx = useRef<number | null>(null); // 드래그가 시작된 요일 칸 칸 번호
  const [dragCurrentSlot, setDragCurrentSlot] = useState<number | null>(null);
  const touchTimer = useRef<NodeJS.Timeout | null>(null);
  const longPressed = useRef<boolean>(false);
  const isProcessing = useRef<boolean>(false);
  const isProcessingTimer = useRef<NodeJS.Timeout | null>(null);    
  const timelineBoardRef = useRef<HTMLDivElement>(null);

  // --- 🧮 30분 슬롯 및 요일 인덱스 추적 계산기 ---
  const getCoordinatesFromEvent = (clientX: number, clientY: number) => {
    if (!timelineBoardRef.current) return { slot: 0, dayIdx: 0 };
    const rect = timelineBoardRef.current.getBoundingClientRect();
    
    // Y축 기준 30분 슬롯 계산
    const relativeY = clientY - rect.top;
    const slot = Math.max(0, Math.min(47, Math.floor(relativeY / SLOT_HEIGHT)));

    // X축 기준 7개 칸 중 몇 번째 요일 칸인지 계산
    const relativeX = clientX - rect.left;
    const dayWidth = rect.width / 7;
    const dayIdx = Math.max(0, Math.min(6, Math.floor(relativeX / dayWidth)));

    return { slot, dayIdx };
  };

  // --- 📱 터치 및 마우스 롱프레스 시작 제어 ---
  const handleStart = (clientX: number, clientY: number, e: any, isTouch: boolean) => {
    if (e.target.closest('.weekly-event-card-item')) return;

    e.preventDefault();

    if (isTouch) {
      if (isProcessingTimer.current) {
        clearTimeout(isProcessingTimer.current);    
        isProcessingTimer.current = null;
      } 
      isProcessing.current = true;
      isProcessingTimer.current = setTimeout(() => {
        isProcessing.current = false;
      }, 500);
    }

    if (touchTimer.current) {
      clearTimeout(touchTimer.current);    
      touchTimer.current = null;
    } 
    longPressed.current = !isTouch; // PC 마우스는 즉시 작동, 모바일 터치는 false 초기화

    const triggerAction = () => {
      const { slot, dayIdx } = getCoordinatesFromEvent(clientX, clientY);
      dragStartSlot.current = slot;
      dragStartDayIdx.current = dayIdx;

      setDragCurrentSlot(slot);
      setIsDragging(true);

      touchTimer.current = null;

      if (isMobile) {
        const cardBody = e.target.closest('.ant-card-body') as HTMLElement;
        if (cardBody) cardBody.style.overflowY = 'hidden';
        document.body.style.overflow = 'hidden';
      }      
    };

    if (isTouch) {
      touchTimer.current = setTimeout(() => {
        longPressed.current = true;
        triggerAction();
      }, 500); // 0.5초 꾹 누르기
    } else {
      triggerAction();
    }
  };  

  const handleMove = (clientX: number, clientY: number, e: any) => {
    if (!longPressed.current) {
      if (touchTimer.current) clearTimeout(touchTimer.current);
      touchTimer.current = null;
      return;
    }

    if (!isDragging) return;

    if (e.cancelable) {
      e.preventDefault();
    } 
    const { slot } = getCoordinatesFromEvent(clientX, clientY);
    setDragCurrentSlot(slot);
  };  

  const handleEnd = (e: any, isTouch: boolean) => {
    if (longPressed.current) {
      if (e.cancelable) {
        e.preventDefault(); // 새로고침 발동 원천 차단
      }
    }

    if (touchTimer.current != null) {
      clearTimeout(touchTimer.current);
      touchTimer.current = null;
    }

    if (isMobile) {
      document.body.style.overflow = 'unset';
      document.querySelectorAll('.ant-card-body').forEach(el => (el as HTMLElement).style.overflowY = 'auto');
    }

    if (!isDragging || !longPressed.current || dragStartSlot.current === null || dragCurrentSlot === null || dragStartDayIdx.current === null) {
      setIsDragging(false);
      longPressed.current = false;
      return;
    }

    const startSlot = Math.min(dragStartSlot.current, dragCurrentSlot);
    const endSlot = Math.max(dragStartSlot.current, dragCurrentSlot) + 1;
    const targetDate = moment(`${moment(currentMonth).format('YYYYMM')}${schedules[dragStartDayIdx.current].day}`).format('YYYY-MM-DD')

    const startTimeStr = convertSlotToTime(startSlot);
    const endTimeStr = convertSlotToTime(endSlot);

    setIsDragging(false);
    dragStartSlot.current = null;
    longPressed.current = false;
    
    onOpenStandbyPopup?.(moment(targetDate, 'YYYY-MM-DD'), startTimeStr, endTimeStr)
  };

  const convertSlotToTime = (slot: number) => {
    const hours = Math.floor(slot / 2);
    const minutes = (slot % 2) * 30;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  };  

  const layoutedEvents = (!schedules || schedules.length == 0) ? [] : schedules.map((schedule) => getLayoutedEvents(schedule.schedules))  ;

  // 드래그 레이어 스타일 계산
  const getDragBoxStyle = (isDragging: boolean) => {
    if (!isDragging || dragStartSlot.current === null || dragCurrentSlot === null || dragStartDayIdx.current === null) return { display: 'none' };

    const start = Math.min(dragStartSlot.current, dragCurrentSlot);
    const end = Math.max(dragStartSlot.current, dragCurrentSlot) + 1;
    const leftPercent = (100 / 7) * dragStartDayIdx.current;

    return {
      position: 'absolute' as const,
      top: `${start * SLOT_HEIGHT}px`,
      height: `${(end - start) * SLOT_HEIGHT}px`,
      left: `${leftPercent}%`,
      width: `${100 / 7}%`,
      background: 'rgba(22, 119, 255, 0.2)',
      border: '1px dashed #1677ff',
      pointerEvents: 'none' as const,
      zIndex: 5,
    };
  };

  useEffect(() => {
    const boardEl = timelineBoardRef.current;
    if (!boardEl) return;

    const handleNativeTouchMove = (e: TouchEvent) => {
      if (touchTimer.current) {
        clearTimeout(touchTimer.current);
        touchTimer.current = null;
      }

      if (longPressed.current) {
        if (e.cancelable) {
          e.preventDefault(); // 새로고침 발동 원천 차단
        }

        const touch = e.touches[0];
        // 기존 handleMove 로직을 네이티브 이벤트 안으로 가져옴
        const { slot } = getCoordinatesFromEvent(touch.clientX, touch.clientY);
        setDragCurrentSlot(slot);
      }
    };

    // 💡 { passive: false } 를 주어야만 e.preventDefault()가 브라우저에 의해 무시되지 않습니다.
    boardEl.addEventListener('touchmove', handleNativeTouchMove, { passive: false });

    return () => {
      boardEl.removeEventListener('touchmove', handleNativeTouchMove);
    };
  }, [isDragging]); // 주석: isDragging 상태 변화에 맞춰 바인딩 유지

  return (
    <div 
      style={{ 
        display: 'flex', 
        width: '100%', 
        background: '#fff', 
        border: '1px solid #f0f0f0', 
        borderRadius: '8px', 
        overflow: 'hidden',
        WebkitUserSelect: 'none',  /* 사파리(iOS/macOS) 지원 */
        MozUserSelect: 'none',     /* 파이어폭스 지원 */
        userSelect: 'none',        /* 크롬, 오페라, 에지 등 표준 브라우저 지원 */    
        contain: 'size layout style', 
        height:`${24 * HOUR_HEIGHT}px`             
      }}
    >
      {/* 1. 왼쪽 영역: 시간 레이블 (고정 폭) */}
      <div style={{ flex: '0 0 60px', background: '#fafafa', borderRight: '1px solid #f0f0f0', position: 'relative', height: `${HOUR_HEIGHT * 24}px` }}>
        {Array.from({ length: 24 }).map((_, hour) => (
          <div
            key={hour}
            style={{
              position: 'absolute',
              top: `${hour * HOUR_HEIGHT - 6}px`, // 글자 중심선을 눈금선과 맞추기 위해 약간 올림
              width: '100%',
              textAlign: 'center',
              fontSize: '11px',
              color: '#8c8c8c',
            }}
          >
            {String(hour).padStart(2, '0')}:00
          </div>
        ))}
      </div> 
      {/* 2. 오른쪽 영역: 실제 스케줄 타임라인 (유연한 폭) */}
      <div 
        ref={timelineBoardRef}
        onMouseDown={(e) => !isProcessing.current && handleStart(e.clientX, e.clientY, e, false)}
        onMouseMove={(e) => !isProcessing.current && handleMove(e.clientX, e.clientY, e)}   
        onMouseUp={(e) => !isProcessing.current && handleEnd(e, false)}
        onTouchStart={(e) => handleStart(e.touches[0].clientX, e.touches[0].clientY, e, true)}
        //onTouchMove={(e) => handleMove(e.touches[0].clientX, e.touches[0].clientY, e)}
        onTouchEnd={(e)=>handleEnd(e, true)}             
        /* PC 환경 */
        style={{ flex: 1, position: 'relative', height: `${HOUR_HEIGHT * 24}px`, touchAction: isDragging ? 'none' : 'pan-y', cursor: 'cell'}}
      >
        {/* 가로 가이드 배경선 그리기 */}
        {Array.from({ length: 24 }).map((_, hour) => (
          <div
            key={hour}
            style={{
              position: 'absolute',
              top: `${hour * HOUR_HEIGHT}px`,
              width: '100%',
              height: `${HOUR_HEIGHT}px`,
              borderBottom: '1px solid #f0f0f0',
              boxSizing: 'border-box',
              pointerEvents: 'none' // 배경선이 스케줄 클릭을 방해하지 않도록 설정
            }}
          />
        ))}

        {/* 7열 세로 경계선 레이아웃 라인 그리기 */}
        {Array.from({ length: 7 }).map((_, day) => (
          <div 
            key={day} 
            style={{ 
              position: 'absolute', 
              left: `${(100 / 7) * day}%`, 
              top: 0, 
              height: '100%', 
              borderRight: '1px solid #f0f0f0', 
              pointerEvents: 'none' 
            }} 
          />
        ))}        

        {/* 실시간 드래그 박스 */}
        <div style={getDragBoxStyle(isDragging)} />


        {/* 계산된 스케줄 항목들을 절대 좌표로 배치 */}
        {layoutedEvents.map((eventList, _index) => {
          const events = eventList.map((event) => {
            const startMoment = moment(event.start_time, 'HH:mm');
            const endMoment = event.start_time != event.end_time ? moment(event.end_time, 'HH:mm'): moment(event.end_time, 'HH:mm').add(30, 'minute');
            
            // Y축 위치 및 높이 산출 (분 단위 연산)
            const top = startMoment.hours() * 60 + startMoment.minutes();
            const height = endMoment.diff(startMoment, 'minutes');

            const dayBaseWidth = 100 / 7;
            const subColWidth = dayBaseWidth / (event.totalCols || 1);
            const leftPosition = (dayBaseWidth * _index) + ((event.colIndex || 0) * subColWidth);


            return (
              <Popover 
                key={event.id}
                placement="rightTop" 
                className="weekly-event-card-item"
                content={makePopupContent(event)}
                //onOpenChange={(open)=>dragStartSlot.current = null}
              >
                <div
                  onClick={()=> {
                    !isMobile && onClickItem(event);
                  }}
                  key={event.id}                          
                  style={{
                    position: 'absolute',
                    top: `${top}px`,
                    height: `${height}px`,
                    left: `${leftPosition}%`,
                    width: `${subColWidth}%`,
                    padding: '2px 4px 2px 2px', // 일정 카드 간 약간의 틈 생성
                    boxSizing: 'border-box',
                  }}
                >
                  {/* 스케줄 카드 내부 디자인 */}
                  <div
                    className={cx(`schedule_event event_status_type_${event.lecture_status_type}`)}
                  >
                    <span className={'lecture_place_type_' + event.lecture_place_type}>
                      {(event.lecture_status_type == '4' || event.lecture_status_type == '0') ? (
                        <span>{event.lecture_status_type == '4'?'논의중':'대기'}_{event.start_time}~{event.end_time}_{event.lecturer_name}_{event.company_name}_{event.lecture_subject}_{event.time_count}H_{event.pm}</span>
                      ):(
                        <span>{event.lecturer_name} {isMobile ? event.lecture_subject:event.project_title} {event.start_time}~{event.end_time}</span>
                      )}                       
                    </span>
                  </div>
                </div>                
              </Popover>              
            );
          })

          return events;
        })}           
      
      </div>      
    </div>
  )
};

export interface CalenderProps {
  current: string;
  schedules: ScheduleListDto[];
  type: string;
  display?: string;
  onPrevMonth: () => void;
  onNextMonth: () => void;
  onExcelDownload: () => void;
  onChangeDisplay?: (e: any) => void;
  onClickItem: (item: DailyScheduleDto)  => void;
  makePopupContent: (item: DailyScheduleDto)  => void;  
  onSetSearchDate: (date: any) => void;
  onGoDay?: (date: any) => void;
  refetch?: () => void;
}

const Calender = ({current, schedules, type, display='month', onPrevMonth, onNextMonth, onClickItem, makePopupContent, onExcelDownload, onChangeDisplay, onSetSearchDate, onGoDay, refetch}: CalenderProps): React.ReactElement => {

  const [currentMonth, setCurrentMonth] = useState(moment());  
  const [currentStatus, setCurrentStatus] = useState<string>('all');
  const [currentSubStatus, setCurrentSubStatus] = useState<string>('all');
  const [currentSchedules, setCurrentSchedules] = useState<ScheduleListDto[]>([]);

  const { open } = usePopupManager();

  const onChangeStatus = (e: any) => {
    setCurrentStatus(e.target.value);
  }

  const onChangeSubStatus = (value: any) => {
    setCurrentSubStatus(value);
  }  

  const onOpenStandbyPopup = (date: any, startTime: any, endTime: any) => {
    open(StandbyScheduleEditModal, {
      id: 0, 
      schedule_date: date,
      schedule_start_time: startTime,
      schedule_end_time: endTime,
      onClose: (isOk)=>{
        if(isOk && refetch) {
          refetch();
        }
      }}
    );
  };


  useEffect(() => {
    if (current)
    setCurrentMonth(moment(current))
  }, [current])

  useEffect(() => {
    if (schedules && schedules.length > 0) {
      const newSchedules = schedules.map((item) => {
        const filterSchedule = item.schedules.filter((schedule) => {
          return (
            type=='op' || 
            currentStatus == 'all' || 
            (currentStatus != 'consult' && schedule.status == currentStatus) ||
            (currentStatus == 'consult' &&  currentSubStatus == 'all' && schedule.status == currentStatus) ||
            (currentStatus == 'consult' &&  currentSubStatus == 'link' && schedule.status == currentStatus && schedule.group_id > 0) ||
            (currentStatus == 'consult' &&  currentSubStatus == 'nolink' && schedule.status == currentStatus && schedule.group_id == 0) ||
            (currentStatus == 'consult' &&  currentSubStatus == 'standby' && schedule.status == currentStatus && schedule.dup_count > 1)
          )
        })  
        return {day: item.day, date: item.date, schedules: filterSchedule}
      })
      setCurrentSchedules(newSchedules);
    } else {
      setCurrentSchedules([]);
    }
    
  }, [schedules, currentStatus, currentSubStatus])  

  useEffect(() => {
    if (isMobile) {
      document.body.style.overflow = 'unset';
      document.querySelectorAll('.ant-card-body').forEach(el => (el as HTMLElement).style.overflowY = 'auto');
    }
  }, [])

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div>
      <div style={{position:'sticky', top: '0.5px', backgroundColor:'#FFF', zIndex:100 }}>
        <div className='schedule_info'>
          <div>
            {(type==='sc') && (
              <div style={{display:'flex', gap: 20}}>
                <Radio.Group
                  options={isMobile?[{label: '월', value:'month'}, {label: '주', value:'week'}, {label: '일', value:'day'}]:[{label: '월간', value:'month'}, {label: '주간', value:'week'}, {label: '일별', value:'day'}]}
                  value={display}
                  optionType="button"
                  buttonStyle="solid"
                  size='small'
                  style={{marginBottom:'5px'}}
                  onChange={(e)=>onChangeDisplay&&onChangeDisplay(e)}
                />
                 {!isMobile && (
                  <div style={{display:'flex'}}>
                    <Radio.Group
                      options={[{label: '전체', value:'all'}, {label: '확정', value:'confirm'}, {label: '논의중', value:'consult'}]}
                      value={currentStatus}
                      optionType="button"
                      buttonStyle="solid"
                      size='small'
                      onChange={(e)=>onChangeStatus&&onChangeStatus(e)}
                    />
                  {currentStatus == 'consult' && (
                    <Select value={currentSubStatus} onSelect={onChangeSubStatus} size="small" style={{width:'120px'}}>
                      <Select.Option key={'all'} value={'all'}>전체</Select.Option>
                      <Select.Option key={'link'} value={'link'}>프로젝트 연결</Select.Option>
                      <Select.Option key={'nolink'} value={'nolink'}>프로젝트 미연결</Select.Option>
                      <Select.Option key={'standby'} value={'standby'}>대기</Select.Option>
                    </Select>
                  )}                    
                  </div>
                )}              
              </div>
            )}
          </div>        
          {(isMobile) ? (
            <>
              {(type==='op')?(
                <Space size={4}>
                  <span className={'lecture_status_type_1'}>●</span><span>완료</span>
                  <span className={'lecture_status_type_3'}>●</span><span>확정</span>
                  <span className={'lecture_status_type_2'}>●</span><span>미배정</span>
                  <Button size='small' icon={<FileExcelOutlined />} onClick={onExcelDownload}>엑셀</Button> 
                </Space>
              ):(
                <Space size={4}>
                  <span className={'lecture_status_type_0'}>●</span><span>대기</span>
                  <span className={'lecture_status_type_1'}>●</span><span>완료</span>
                  <span className={'lecture_status_type_2'}>●</span><span>미평가</span>
                  <span className={'lecture_status_type_3'}>●</span><span>확정</span>
                  <span className={'lecture_status_type_4'}>●</span><span>논의</span>
                  <span className='lecture_place_type_ONLINE'>온</span>
                  <span className='lecture_place_type_OFFLINE'>오프</span>
                  <Button size='small' icon={<FileExcelOutlined/>} onClick={onExcelDownload}></Button> 
                  <Button size='small' icon={<PlusOutlined />} onClick={onExcelDownload}></Button>
                </Space>
              )}     
            </>    
          ) : (
            <>          
              {(type==='op')?(
                <Space size={8}>
                  <span className={'lecture_status_type_1'}>●</span><span>완료</span>
                  <span className={'lecture_status_type_3'}>●</span><span>확정</span>
                  <span className={'lecture_status_type_2'}>●</span><span>미배정</span>
                  <Button size='small' icon={<FileExcelOutlined />} onClick={onExcelDownload}>엑셀다운로드</Button> 
                </Space>
              ):(
                <Space size={8}>
                  <span className={'lecture_status_type_0'}>●</span><span>대기</span>
                  <span className={'lecture_status_type_1'}>●</span><span>완료</span>
                  <span className={'lecture_status_type_2'}>●</span><span>평가 미입력</span>
                  <span className={'lecture_status_type_3'}>●</span><span>확정</span>
                  <span className={'lecture_status_type_4'}>●</span><span>논의</span>
                  <span className='lecture_place_type_ONLINE'>온라인</span>
                  <span className='lecture_place_type_OFFLINE'>오프라인</span>
                  <Button size='small' icon={<FileExcelOutlined />} onClick={onExcelDownload}>엑셀다운로드</Button>
                  <Button size='small' icon={<PlusOutlined />} onClick={()=>onOpenStandbyPopup(moment().format('YYYY-MM-DD'), '09:00', '10:00')}>일정등록</Button>
                </Space>
              )}
                        
            </>  
          )}
        </div>      
        <RenderHeader 
          currentMonth={currentMonth} 
          display={display} 
          prevMonth={onPrevMonth} 
          nextMonth={onNextMonth} 
          onSetSearchDate={onSetSearchDate} 
          status={currentStatus} 
          onChangeStatus={onChangeStatus}
          subStatus={currentSubStatus}
          onChangeSubStatus={onChangeSubStatus}
        />
        {(display === 'day') ? (
          <div style={{width:'60px', textAlign:'center', height:30, fontWeight:500}}>{moment(currentMonth).format('D (dd)')}</div>
        ): (display === 'week') ? (
          RenderWeek(currentSchedules, currentMonth, (date)=> onGoDay?onGoDay(date):null)
        ) : (
          <RenderDays />
        )}
      </div>
      {(display === 'day') ? (
        <RenderDisplayDay 
            currentMonth={currentMonth}
            schedules={currentSchedules}
            type={type}
            onClickItem={onClickItem}
            makePopupContent={makePopupContent}
            onOpenStandbyPopup={onOpenStandbyPopup}
        />          
      ) : (display === 'week') ? (
        <RenderDisplayWeek 
            currentMonth={currentMonth}
            schedules={currentSchedules}
            type={type}
            onClickItem={onClickItem}
            makePopupContent={makePopupContent}
            onOpenStandbyPopup={onOpenStandbyPopup}
        />          
      ) : (
        <RenderCells 
            currentMonth={currentMonth}
            schedules={currentSchedules}
            type={type}
            onClickItem={onClickItem}
            makePopupContent={makePopupContent}
            onOpenStandbyPopup={onOpenStandbyPopup}
            onGoDay={(date)=>onGoDay?onGoDay(date):null}
        />          
        )}
    </div>
  );
};

export default React.memo(Calender);
